/**
 * A thin, always-visible marker on the staging build (VITE_DEPLOY_ENV=staging,
 * set by frontend/.env.staging). Staging looks exactly like production and
 * talks to Halo MTS's real ConnectWise, so nobody should be able to forget
 * which one they are in — least of all with a card form open.
 *
 * Renders nothing in a production build; the condition is a build-time
 * constant, so the production bundle carries no ribbon at all.
 *
 * The operator console (manage.) is the one host where "test payments only"
 * is the wrong warning — nobody pays there — but it is still staging's
 * console managing staging's tenants, so it keeps the strip and loses the
 * payments wording.
 */
export default function StagingRibbon() {
  if (import.meta.env.VITE_DEPLOY_ENV !== 'staging') return null;
  const manage = typeof window !== 'undefined' && /^manage\./i.test(window.location.hostname);
  return (
    <div
      role="note"
      aria-label="Staging environment"
      className="pointer-events-none fixed inset-x-0 top-0 z-[9999] h-1 bg-amber-500"
    >
      <span className="absolute left-1/2 top-0 -translate-x-1/2 rounded-b bg-amber-500 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-black shadow">
        {manage ? 'Staging environment' : 'Staging — test payments only'}
      </span>
    </div>
  );
}
